import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { EmailFormModule } from '../email-form/email-form.module';
import { MatDialogModule } from '@angular/material/dialog';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';

@NgModule({
    declarations: [DialogComponent],
    imports: [
        CommonModule,
        EmailFormModule,
        MatDialogModule,
        AppAnalyticsModule,
    ],
})
export class DialogModule {}
